import _ from 'lodash';

/** ReCaptchaでトークンを取得する */
export const submit = (value: any, setReCaptchaToken: any) => {
  setReCaptchaToken(value);
};

/** サブミットしたことがあって、ReCaptchaにチェックを入れていない */
export const error = (submitCount: any, token: null | string) => {
  if (submitCount > 0 && _.isEmpty(token)) {
    return 'チェックを入れてください';
  }
  return null;
};
